import { InAppBrowser } from '@/src/common/components/InAppBrowser'
import { routerBack } from '@/src/common/utils/routerBack'

export default function Support() {
  const title = 'Support'
  const uri = 'https://mesamember.com/'
  return (
    <InAppBrowser
      title={title}
      uri={uri}
      onBackPress={() => {
        void routerBack()
      }}
    />
  )
}
